import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as Controls from 'Flow2/config/Controls';

class MetadataPermissionHelper {

    static hasPermission(props) {
        switch (props.type) {
            case metadata.OBJECT_TYPE_CLIP:
                //return true;
                //console.log(props.user.granting.get('editclip', { clip: props.originalObject }));
                //return props && props.user && props.user.granting && props.user.granting.get && props.user.granting.get('editclip') || false;
				try {                
					return (props && props.user && props.user.granting && props.user.granting.get && props.user.granting.get('editclip', { clip: props.originalObject })) || false;
				} catch(e) {
					console.log(e);
					return false;
				}
            case metadata.OBJECT_TYPE_ROOM:
                //console.log('editshowrooms '+props.user.granting.get('editshowrooms', { room: { metadata: {...props.data, get: (key) => { return props.data[key]; }}}}));
                //return true;
                //props.data.owner = '***************username***************';
                //return props && props.user && props.user.granting && props.user.granting.get && props.user.granting.get('editshowrooms', { room: { metadata: {...props.data, get: (key) => { return props.data[key]; }}}}) || false;
				try {
					return (props && props.user && props.user.granting && props.user.granting.get && props.user.granting.get('editshowrooms', { room: props.originalObject })) || false;
				} catch(e) {
					console.log(e);
					return false;
				}
            case metadata.OBJECT_TYPE_PROJECT:
                //console.log('editprojects '+props.user.granting.get('editprojects', { project: { metadata: {...props.data, get: (key) => { return props.data[key]; }}}}));
                //return true;
                //props.data.owner = '***************username***************';
                //return props && props.user && props.user.granting && props.user.granting.get && props.user.granting.get('editproject', { project: { metadata: {...props.data, get: (key) => { return props.data[key]; }}}}) || false;
                //console.log(props);
				try {
					return (props && props.user && props.user.granting && props.user.granting.get && props.user.granting.get('editproject', { project: props.originalObject.originalObject })) || false;
				} catch(e) {
					console.log(e);
					return false;
				}
            default:
                return true;
        }
    }

    static hasFieldPermission(props, field, action = 'see') {
        switch (props.type) {
            case metadata.OBJECT_TYPE_CLIP:
				try {
					return !props.user.granting.get('clipfieldconstraints', { clip: props.originalObject, targetfield: field, action: action });
				} catch(e) {
					console.log(e);
					return false;
				}
            case metadata.OBJECT_TYPE_PROJECT:
                try {
					return !props.user.granting.get('projectfieldconstraints', { project: props.originalObject.originalObject, targetfield: field, action: action });
				} catch(e) {
					console.log(e);
					return false;
				}
            default:
                return true;
        }
    }

    static hasDeletePermission(props) {
        //return true;
        switch (props.type) {
            case metadata.OBJECT_TYPE_CLIP:
                //return true;
                return props.user.granting.get('deleteclip', { clip: props.originalObject });
            case metadata.OBJECT_TYPE_ROOM:
                //return true;
                return props.user.granting.get('deleteroom', {});
            case metadata.OBJECT_TYPE_PROJECT:
                //return true;
                return props.user.granting.get('deleteproject', {});
            default:
                return true;
        }
    }
    
    static showControl(config, control) {
        if(!control || !config || !config.hiddenControls) {
            return true;
        }
        
        return config.hiddenControls.indexOf(control) === -1;
    }
}

export default MetadataPermissionHelper;

